export const TikTokIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.5 3c.3 2.2 1.6 3.8 3.9 4.1v2.7c-1.4.1-2.7-.3-3.9-1v5.9c0 3.6-2.6 5.8-5.7 5.8-3 0-5.2-2.2-5.2-5.1 0-3 2.3-5.1 5.4-4.9v2.8c-.5-.1-1-.1-1.5 0-1.1.3-1.8 1.1-1.7 2.3.1 1.3 1.1 2 2.3 1.9 1.3-.1 2-1 2-2.5V3h3.9z" />
  </svg>
);

export const InstagramIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" className={className} aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
  </svg>
);
